import { useCallback } from "react";
import { useToast } from "../context/ToastContext";
import { profile } from "../data/resume";

const useCopyEmail = () => {
  const notify = useToast();

  return useCallback(async () => {
    try {
      await navigator.clipboard.writeText(profile.email);
      notify("Email copied to clipboard");
    } catch (e) {
      window.location.href = `mailto:${profile.email}`;
    }
  }, [notify]);
};

export default useCopyEmail;
